import ExitSlide from "./ExitSlide";
import ExitSlide2 from "./ExitSlide2";
import ExitSlide3 from "./ExitSlide3";
import QuestionPromptSlide from "./QuestionPromptSlide";
import QuestionPromptSlide2 from "./QuestionPromptSlide2";
import QuestionPromptSlide3 from "./QuestionPromptSlide3";
import SummarySlide from "./SummarySlide";

export const finalSchemas = [
  ExitSlide,
  ExitSlide2,
  ExitSlide3,
  QuestionPromptSlide,
  QuestionPromptSlide2,
  QuestionPromptSlide3,
  SummarySlide,
];

export default finalSchemas;
